import "./App.css";
import React, { useState } from "react";
import PreService from "./components/PreService";
import CallToWorship from "./components/CallToWorship";
import WorshipSong from "./components/WorshipSong";
import Announcement from "./components/Announcement";
import Offering from "./components/Offering";
import PastorIntro from "./components/PastorIntro";
import PastorSermon from "./components/PastorSermon";
import ClosingPrayer from "./components/ClosingPrayer";
import LastWorship from "./components/LastWorship";

function App() {
  const [showPreService, setShowPreService] = useState(true);

  return (
    <div className="bg-black text-white font-sans min-h-screen">
      {showPreService ? (
        <PreService onComplete={() => setShowPreService(false)} />
      ) : (
        <>
          <CallToWorship />

          <WorshipSong
            title="1st Worship Song"
            youtubeUrl="https://www.youtube.com/embed/YTeWThXzavs"
          />

          <WorshipSong
            title="2nd Worship Song"
            youtubeUrl="https://www.youtube.com/embed/YTeWThXzavs"
          />

          <Announcement />

          <WorshipSong
            title="3rd Worship Song"
            youtubeUrl="https://www.youtube.com/embed/YTeWThXzavs"
          />

          <WorshipSong
            title="4th Worship Song"
            youtubeUrl="https://www.youtube.com/embed/YTeWThXzavs"
          />

          <Offering />
          <PastorIntro />
          <PastorSermon />
          <ClosingPrayer />
          <LastWorship />
        </>
      )}
    </div>
  );
}

export default App;